import type { IVariantSummary } from "~/hooks/useVariantTableData"

export function isFashion(entry: Pick<IVariantSummary, "settings"> | undefined | null): boolean {
  return entry?.settings?.productType === "fashion"
}

export function isAllFashion(
  entries: ReadonlyArray<Pick<IVariantSummary, "settings"> | undefined | null>,
): boolean {
  return entries.every((e) => isFashion(e))
}
